import { useRouter } from "next/router";

import { Text } from "@/components/elements";

import styles from "./styles.module.css";

const formatDate = (isoDate: string, locale: string) =>
  new Intl.DateTimeFormat(locale, {
    month: "long",
    day: "numeric",
  }).format(new Date(isoDate));

export const Title = ({ content }) => {
  const { locale } = useRouter();
  const { publishedAt, main_title } = content;
  const author = `${locale.includes("en") ? "BY" : "AV"} PÅ(FYLL)™`;

  return (
    <>
      <Text as="h1" size="xl" responsive className={styles.h1}>
        {main_title}
      </Text>

      {publishedAt && (
        <Text size="xs" responsive className={styles.date}>
          {formatDate(publishedAt, locale)} | {author}
        </Text>
      )}
    </>
  );
};
